import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-379e75ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-col ant-col-xs-24 ant-col-xl-24 ss-botoes-agendamento-superior" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-15" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-19" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-22" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_21 = { class: "ant-btn-group ss-botoes-comentarios" }
const _hoisted_22 = { class: "ss-comentario" }
const _hoisted_23 = { class: "ss-comentario-identificacao" }
const _hoisted_24 = { class: "ss-comentario-acoes" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Editar comentário", -1))
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Excluir comentário", -1))
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "ant-row" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-1" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  style: {"padding-left":"8px"},
  class: "ant-input",
  value: "A",
  disabled: ""
}, null, -1))
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-15" }
const _hoisted_37 = { class: "ant-row" }
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_39 = { class: "ant-row" }
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_41 = { class: "ant-row ss-margin-cor" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-form-item ss-margin-campos" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "Cor" }, "Cor")
  ])
], -1))
const _hoisted_43 = { class: "ant-col ant-col-xs-24 ant-col-xl-23" }
const _hoisted_44 = { class: "ant-row" }
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_46 = { class: "ant-row" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_navegacao_registro = _resolveComponent("navegacao-registro")!
  const _component_barra_progresso = _resolveComponent("barra-progresso")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_selecionar_usuario_agrupado_perfil_modal = _resolveComponent("selecionar-usuario-agrupado-perfil-modal")!
  const _component_selecionar_cor = _resolveComponent("selecionar-cor")!
  const _component_selecionar_marcador = _resolveComponent("selecionar-marcador")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      width: 1000,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      centered: true,
      footer: null
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Agendamento ")
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.telaBase.apresentarBarraProgresso? 'ant-row ss-bloquear-tela': 'ant-row')
        }, [
          _createElementVNode("div", _hoisted_1, [
            _withDirectives(_createVNode(_component_navegacao_registro, {
              onPrimeiro: _cache[0] || (_cache[0] = ($event: any) => (_ctx.obterAgendamento(_ctx.stateModal.agendamento.codigo,_ctx.ENavegacaoRegistro.Primeiro,_ctx.stateModal.agendamento.dataHoraInicio))),
              onAnterior: _cache[1] || (_cache[1] = ($event: any) => (_ctx.obterAgendamento(_ctx.stateModal.agendamento.codigo,_ctx.ENavegacaoRegistro.Anterior,_ctx.stateModal.agendamento.dataHoraInicio))),
              onProximo: _cache[2] || (_cache[2] = ($event: any) => (_ctx.obterAgendamento(_ctx.stateModal.agendamento.codigo,_ctx.ENavegacaoRegistro.Proximo,_ctx.stateModal.agendamento.dataHoraInicio))),
              onUltimo: _cache[3] || (_cache[3] = ($event: any) => (_ctx.obterAgendamento(_ctx.stateModal.agendamento.codigo,_ctx.ENavegacaoRegistro.Ultimo,_ctx.stateModal.agendamento.dataHoraInicio))),
              onExcluir: _ctx.confirmaExclusao,
              exibirExcluir: true
            }, null, 8, ["onExcluir"]), [
              [_vShow, _ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar]
            ]),
            _createElementVNode("button", {
              type: "button",
              style: {"margin-left":"20px"},
              class: "ant-btn ant-btn-primary ss-btn-acao-destaque",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
            }, _hoisted_3)
          ])
        ], 2),
        (_ctx.telaBase.apresentarBarraProgresso)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_barra_progresso, {
                visivel: _ctx.telaBase.apresentarBarraProgresso,
                "onUpdate:visivel": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telaBase.apresentarBarraProgresso) = $event))
              }, null, 8, ["visivel"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando,
          paragraph: { rows: 10 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              layout: "vertical",
              class: _normalizeClass(_ctx.telaBase.apresentarBarraProgresso? 'ss-bloquear-tela': '')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_a_form_item, {
                      label: "Tipo",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.stateModal.agendamento.tipoAgendamento,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.stateModal.agendamento.tipoAgendamento) = $event)),
                          placeholder: "Selecione um tipo",
                          class: "ss-tamanho-completo",
                          options: _ctx.stateModal.listaTipoAgendamento
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_a_form_item, {
                      label: "Título",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_a_checkbox, {
                          class: "ss-apresentar-superior-direito",
                          checked: _ctx.stateModal.agendamento.concluido,
                          "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.stateModal.agendamento.concluido) = $event)),
                          onChange: _ctx.definirDataHoraConclusao
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Concluído ")
                          ]),
                          _: 1
                        }, 8, ["checked", "onChange"]), [
                          [_vShow, _ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "250",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.stateModal.agendamento.titulo) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.stateModal.agendamento.titulo]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_form_item, {
                      label: "Data/Hora Início",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.stateModal.agendamento.dataHoraInicio,
                          "onUpdate:dataSelecionada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.stateModal.agendamento.dataHoraInicio) = $event)),
                          horaMinutoSegundo: true,
                          onChange: _ctx.defineDataHorarioNotificacao
                        }, null, 8, ["dataSelecionada", "onChange"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_a_form_item, {
                      label: "Pessoa",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_pessoa, {
                          codigosSelecionados: _ctx.stateModal.pessoasSelecionadas,
                          "onUpdate:codigosSelecionados": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.stateModal.pessoasSelecionadas) = $event)),
                          recursoOrigem: "AGENDAMENTO",
                          varios: true,
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          placeholder: "Selecione uma ou mais pessoas"
                        }, null, 8, ["codigosSelecionados", "empresas"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_form_item, {
                      label: "Data/Hora Fim",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.stateModal.agendamento.dataHoraFim,
                          "onUpdate:dataSelecionada": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.stateModal.agendamento.dataHoraFim) = $event)),
                          horaMinutoSegundo: true
                        }, null, 8, ["dataSelecionada"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_a_tabs, { class: "ss-margin-campos" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tab_pane, {
                          key: "1",
                          tab: "Descrição"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_editor_html, {
                                  value: _ctx.stateModal.agendamento.descricao,
                                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.stateModal.agendamento.descricao) = $event))
                                }, null, 8, ["value"])
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar)
                          ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                              key: "2",
                              tab: "Comentários"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("div", _hoisted_19, [
                                        _withDirectives(_createElementVNode("textarea", {
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.stateModal.comentario) = $event)),
                                          placeholder: "Digite seu comentário aqui",
                                          class: "ant-input ss-comentario-padrao"
                                        }, null, 512), [
                                          [_vModelText, _ctx.stateModal.comentario]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, [
                                          _createVNode(_component_a_tooltip, { placement: "top" }, {
                                            title: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.stateModal.codigoComentarioEmAlteracao > 0? 'Cancelar alteração': 'Limpar comentário'), 1)
                                            ]),
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("button", {
                                                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.cancelarEdicaoComentario && _ctx.cancelarEdicaoComentario(...args))),
                                                class: "ant-btn ss-comentario-padrao ant-btn-block"
                                              }, [
                                                _createVNode(_component_icone, { nome: "cancelar" })
                                              ], 512), [
                                                [_vShow, _ctx.stateModal.comentario]
                                              ])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_a_tooltip, { placement: "top" }, {
                                            title: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.stateModal.codigoComentarioEmAlteracao > 0? 'Salvar comentário': 'Adicionar comentário'), 1)
                                            ]),
                                            default: _withCtx(() => [
                                              _createElementVNode("button", {
                                                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.adicionarComentario && _ctx.adicionarComentario(...args))),
                                                class: "ant-btn ant-btn-primary ss-comentario-padrao ant-btn-block"
                                              }, [
                                                _createVNode(_component_icone, { nome: "enviar" })
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("ul", _hoisted_22, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateModal.agendamento.comentarios, (comentario, index) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          class: "ss-comentario",
                                          key: index
                                        }, [
                                          _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(comentario.dataHora)) + " - " + _toDisplayString(_ctx.obtemDadosUsuario(comentario.codigoUsuario)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_24, [
                                            _createVNode(_component_a_tooltip, { placement: "top" }, {
                                              title: _withCtx(() => [
                                                _hoisted_25
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("a", {
                                                  class: "visualizar",
                                                  onClick: ($event: any) => (_ctx.editarComentario(comentario.codigo,comentario.comentario))
                                                }, [
                                                  _createVNode(_component_icone, { nome: "editar" })
                                                ], 8, _hoisted_26)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_a_tooltip, { placement: "top" }, {
                                              title: _withCtx(() => [
                                                _hoisted_27
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("a", {
                                                  class: "excluir",
                                                  onClick: ($event: any) => (_ctx.excluirComentario(comentario.codigo,index))
                                                }, [
                                                  _createVNode(_component_icone, { nome: "excluir" })
                                                ], 8, _hoisted_28)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _createElementVNode("span", null, _toDisplayString(comentario.comentario), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir)
                          ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                              key: "3",
                              tab: "Repetir"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_a_checkbox, {
                                      checked: _ctx.stateModal.repetirAgendamento,
                                      "onUpdate:checked": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.stateModal.repetirAgendamento) = $event)),
                                      onChange: _ctx.verificaDataMinimaRepeticao
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Desejo repetir este agendamento ")
                                      ]),
                                      _: 1
                                    }, 8, ["checked", "onChange"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Período",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_data, {
                                          dataSelecionada: _ctx.stateModal.dataInicioRepeticao,
                                          "onUpdate:dataSelecionada": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.stateModal.dataInicioRepeticao) = $event)),
                                          placeholder: 'Defina a Data/Hora Início',
                                          disabled: true
                                        }, null, 8, ["dataSelecionada"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_33, [
                                    _createVNode(_component_a_form_item, {
                                      label: " ",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_34
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_35, [
                                    _createVNode(_component_a_form_item, {
                                      label: " ",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_data, {
                                          dataSelecionada: _ctx.stateModal.dataFimRepeticao,
                                          "onUpdate:dataSelecionada": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.stateModal.dataFimRepeticao) = $event)),
                                          onChange: _ctx.verificaDataMinimaRepeticao,
                                          disabled: _ctx.stateModal.repetirAgendamento? false:true
                                        }, null, 8, ["dataSelecionada", "onChange", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_36, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Criar um agendamento",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_select, {
                                          value: _ctx.stateModal.intervaloRepeticao,
                                          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.stateModal.intervaloRepeticao) = $event)),
                                          placeholder: "Selecione o intervalo",
                                          class: "ss-tamanho-completo",
                                          options: _ctx.stateModal.listaIntervaloRepeticaoFiltrada,
                                          disabled: (_ctx.stateModal.listaIntervaloRepeticaoFiltrada.length <= 0)
                                        }, null, 8, ["value", "options", "disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.stateModal.agendamento.concluido?'ant-col ant-col-xs-24 ant-col-xl-6':'ant-col ant-col-xs-24 ant-col-xl-8')
                  }, [
                    _createVNode(_component_a_form_item, {
                      label: "Notificar",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.stateModal.agendamento.tempoNotificacao,
                          "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.stateModal.agendamento.tempoNotificacao) = $event)),
                          placeholder: "Selecione",
                          class: "ss-tamanho-completo",
                          options: _ctx.stateModal.listaTempoNotificacoes,
                          onChange: _ctx.defineDataHorarioNotificacao
                        }, null, 8, ["value", "options", "onChange"])
                      ]),
                      _: 1
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.stateModal.agendamento.concluido?'ant-col ant-col-xs-24 ant-col-xl-6':'ant-col ant-col-xs-24 ant-col-xl-8')
                  }, [
                    _createVNode(_component_a_form_item, {
                      label: "Data/Hora",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.stateModal.agendamento.dataHoraNotificacao,
                          "onUpdate:dataSelecionada": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.stateModal.agendamento.dataHoraNotificacao) = $event)),
                          horaMinutoSegundo: true,
                          placeholder: _ctx.stateModal.agendamento.tempoNotificacao === _ctx.ETempoNotificacaoAgendamento.NaoNotificar? '':'Selecionar data',
                          disabled: _ctx.stateModal.agendamento.tempoNotificacao === _ctx.ETempoNotificacaoAgendamento.NaoNotificar? true:false,
                          onChange: _ctx.defineTempoNotificacao
                        }, null, 8, ["dataSelecionada", "placeholder", "disabled", "onChange"])
                      ]),
                      _: 1
                    })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.stateModal.agendamento.concluido?'ant-col ant-col-xs-24 ant-col-xl-6':'ant-col ant-col-xs-24 ant-col-xl-8')
                  }, [
                    _createVNode(_component_a_form_item, {
                      label: "Tipo da notificação",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.stateModal.agendamento.tipoNotificacao,
                          "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.stateModal.agendamento.tipoNotificacao) = $event)),
                          placeholder: "Selecione",
                          class: "ss-tamanho-completo",
                          options: _ctx.stateModal.listaTipoNotificacoes,
                          disabled: _ctx.stateModal.agendamento.tempoNotificacao === _ctx.ETempoNotificacaoAgendamento.NaoNotificar? true:false
                        }, null, 8, ["value", "options", "disabled"])
                      ]),
                      _: 1
                    })
                  ], 2),
                  _withDirectives(_createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_a_form_item, {
                      label: "Data/Hora conclusão",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.stateModal.agendamento.dataHoraConclusao,
                          "onUpdate:dataSelecionada": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.stateModal.agendamento.dataHoraConclusao) = $event)),
                          horaMinutoSegundo: true,
                          placeholder: '',
                          disabled: true
                        }, null, 8, ["dataSelecionada"])
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, _ctx.stateModal.agendamento.concluido]
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_a_form_item, {
                      label: "Participantes internos",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          class: "ss-apresentar-superior-direito ss-fonte-negrito ss-botao-acima-campo",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.stateModal.adicionarParticipante = true))
                        }, "Selecionar"),
                        _createVNode(_component_selecionar_usuario, {
                          codigosSelecionados: _ctx.stateModal.participantesSelecionados,
                          "onUpdate:codigosSelecionados": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.stateModal.participantesSelecionados) = $event)),
                          varios: true,
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          placeholder: "Digite para pesquisar..."
                        }, null, 8, ["codigosSelecionados", "empresas"]),
                        _createVNode(_component_selecionar_usuario_agrupado_perfil_modal, {
                          visivel: _ctx.stateModal.adicionarParticipante,
                          "onUpdate:visivel": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.stateModal.adicionarParticipante) = $event)),
                          titulo: "Selecione um ou mais participantes",
                          apenasAtivos: true,
                          ignorarUsuarioAutenticado: true,
                          apresentarEmpresas: false,
                          empresas: _ctx.telaBase.empresasSelecionadas,
                          onUsuariosSelecionados: _ctx.adicionaParticipantesSelecionados
                        }, null, 8, ["visivel", "empresas", "onUsuariosSelecionados"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_selecionar_cor, {
                      cor: _ctx.stateModal.agendamento.cor,
                      "onUpdate:cor": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.stateModal.agendamento.cor) = $event))
                    }, null, 8, ["cor"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_a_form_item, {
                      label: "Marcadores",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_marcador, {
                          marcadoresSelecionados: _ctx.stateModal.marcadoresSelecionados,
                          "onUpdate:marcadoresSelecionados": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.stateModal.marcadoresSelecionados) = $event)),
                          codigoUsuario: _ctx.stateModal.agendamento.codigoUsuario,
                          "onUpdate:codigoUsuario": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.stateModal.agendamento.codigoUsuario) = $event)),
                          placeholder: "Digite para definir um marcador"
                        }, null, 8, ["marcadoresSelecionados", "codigoUsuario"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_card, { titulo: "Identificação do agendamento" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_a_form_item, {
                          label: "Código",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              disabled: "",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.stateModal.agendamento.codigo) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.stateModal.agendamento.codigo]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_a_form_item, {
                          label: "Empresa",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_empresa, {
                              codigoSelecionado: _ctx.stateModal.agendamento.codigoEmpresa,
                              "onUpdate:codigoSelecionado": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.stateModal.agendamento.codigoEmpresa) = $event)),
                              onChange: _ctx.verificarAlteracaoEmpresa
                            }, null, 8, ["codigoSelecionado", "onChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_a_form_item, {
                          label: "Usuário",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_usuario, {
                              codigoSelecionado: _ctx.stateModal.agendamento.codigoUsuario,
                              "onUpdate:codigoSelecionado": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.stateModal.agendamento.codigoUsuario) = $event)),
                              disabled: _ctx.props.autorizacaoTodosUsuarios?false:true
                            }, null, 8, ["codigoSelecionado", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}